// Builds the link an agent shares with customers, from the partner's
// `agent_referral_link` config (partner-configurations service). Returns null
// when the link should not be shown.
export function buildAgentReferralLink(config, environment, agent) {
  if (!config || !config.enabled || !agent) {
    return null
  }

  const isProd = environment === 'prod'
  const base = isProd ? config.base_url_production : config.base_url_staging
  if (!base) {
    return null
  }

  const values = {
    agent: agent.name,
    agent_guid: agent.guid,
    agent_email: agent.email,
    created_by: agent.name
  }
  const params = config.params || []
  for (let i = 0; i < params.length; i++) {
    // Email is optional; everything else identifies the agent for attribution.
    if (!values[params[i]] && params[i] !== 'agent_email') {
      return null
    }
  }

  const pairs = []
  if (config.partner_param) {
    pairs.push(['partner', config.partner_param])
  }
  pairs.push(['environment', environment])
  params.forEach(function(key) {
    if (values[key]) {
      pairs.push([key, values[key]])
    }
  })

  const query = pairs
    .map(function(pair) {
      return `${pair[0]}=${encodeURIComponent(pair[1])}`
    })
    .join('&')
  const root = base.replace(/\/$/, '')

  if (config.format === 'base64_q') {
    return `${root}/?q=${encodeURIComponent(btoa(query))}`
  }
  return `${root}/?${query}`
}
